import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AddBlog from '@/views/settings/blogs/blog-create.vue'
import BlogDetails from '@/views/settings/blogs/blog-details.vue'
import EditBlog from '@/views/settings/blogs/blog-edit.vue.vue'
import BlogSettings from '@/views/settings/blogs/index.vue'
import CommissionSettings from '@/views/settings/commissions/index.vue'
import DiscountSettings from '@/views/settings/discounts/index.vue'
import NotUsedDiscount from '@/views/settings/discounts/not-used-discount.vue'
import UsedDiscount from '@/views/settings/discounts/used-discount.vue'
import SettingsIndex from '@/views/settings/index.vue'
import ValiditySettings from '@/views/settings/offers-validity.vue'
import PaymentSettingsMethod from '@/views/settings/payment-methods/index.vue'
import PaymentSettings from '@/views/settings/payments/index.vue'
import CategoriesSettings from '@/views/settings/service-categories/index.vue'
import ProvidersSettings from '@/views/settings/service-providers/index.vue'

const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'Settings', component: SettingsIndex },
      { path: 'discounts', name: 'Discount-Settings', component: DiscountSettings },
      { path: 'service-categories', name: 'Categories-Settings', component: CategoriesSettings },
      { path: 'commissions', name: 'Commission-Settings', component: CommissionSettings },
      { path: 'offers-validity', name: 'Validity-Settings', component: ValiditySettings },
      { path: 'blog', name: 'Blog-Settings', component: BlogSettings },
      { path: 'blog/add', name: 'Add-Blog', component: AddBlog },
      { path: 'blog/:id', name: 'Blog-Details', component: BlogDetails },
      { path: 'blog/:id/edit', name: 'Edit-Blog', component: EditBlog },
      { path: 'payments', name: 'Payment-Settings', component: PaymentSettings },
      { path: 'payment-methods', name: 'Payment-Methods', component: PaymentSettingsMethod },
      { path: 'service-providers', name: 'Providers-Settings', component: ProvidersSettings },
    ],
  },
  {
    path: '/discounts/:id',
    name: 'Used-Discount',
    component: UsedDiscount,
    meta: { layout: DefaultLayout, middleware: ['auth'] },
  },
  {
    path: '/discounts/:id/not-used-users',
    name: 'NotUsed-Discount',
    component: NotUsedDiscount,
    meta: { layout: DefaultLayout, middleware: ['auth'] },
  },
]

export default settingsRoutes
